/* eslint-disable */
const invoicelist = {
  data: [{
    id: '',
    invoice_number: '12345',
    status: 1,
    count: 2,
    invoice_amount: 1234.56,
    created_at: (new Date()).toISOString(),
    updated_at: '',
    voucher: {
      id: '',
      type: 'debit/credit',
      number: '22345',
      value: 100
    }
  }]
}

const payment = {
    "id": "0000000173c67a892e70c458",
    "order_number": "PND-ORD-1",
    "delivery_type": "FTL",
    "igst_tax": 5,
    "state_tax": 2,
    "central_tax": 2,
    "service_recipient": 1,
    "status": 1,
    "paid_to": 1,
    "depot": {
      "id": "00000002ee95a2891545a707",
      "name": "PHILIPS Lighting INDIA LIMITED - Chennai",
      "city": "Chennai",
      "state": "Tamil Nadu",
      "region": "South"
    },
    "consignees": [
      {
        "id": "000003e7ee95a28915455294",
        "city": "Chennai",
        "state": "Tamil Nadu",
        "region": "South",
        "delivered_at": "2017-07-20T12:58:00.000Z",
        "lr_number": ""
      }
    ],
    "vehicle": {
      "id": "5b448e669e0efe89cd597fb7",
      "number": "TN 20 AS 4900"
    },
    "vehicle_type": {
      "id": "0000001073c67a892e715b86",
      "name": "120 CFT",
      "type": "FTL"
    },
    "system": {
      "no_tax": 51,
      "lr_charge": 0,
      "oda_charges": 0,
      "total_amount": 1020,
      "transit_delay": 0,
      "arrived_delay": 0,
      "extra_charges": 0,
      "service_charge": 0,
      "loading_charge": 0,
      "transit_charge": 0,
      "contract_price": 1020,
      "arrived_charge": 0,
      "delivery_delay": 0,
      "delivery_charge": 0,
      "detention_delay": 0,
      "detention_charge": 0,
      "unloading_charge": 0,
      "additional_point_charges": 0,
      "consignment": []
    },
    "transporter": {
      "no_tax": 67.52,
      "lr_charge": 0,
      "oda_charges": 45,
      "total_amount": 1688,
      "transit_delay": 0,
      "arrived_delay": 0,
      "extra_charges": 0,
      "service_charge": 0,
      "loading_charge": 0,
      "transit_charge": 0,
      "contract_price": 1027,
      "arrived_charge": 0,
      "delivery_delay": 0,
      "delivery_charge": 0,
      "detention_delay": 0,
      "detention_charge": 560,
      "unloading_charge": 0,
      "additional_point_charges": 56,
      "consignment": []
    },
    "created_at": "2017-07-20T12:58:00.000Z",
    "updated_at": "2017-07-20T12:58:00.000Z"
};

const invoicedetail = {
  data: {
    id: '',
    invoice_number: '12345',
    status: 1,
    invoice_amount: 1234.56,
    created_at: (new Date()).toISOString(),
    updated_at: '',
    payments: [
      payment
    ],
    comments: [
      {}
    ],
    voucher: {
      id: '',
      type: 'debit/credit',
      number: '22345',
      value: 100
    }
  }
}

export default {
  invoicelist,
  invoicedetail,
};
